import ProductData from "./ProductData";
import apiDoorDataSchema from "../../services/bimVisualizerApi/schema/productData/apiDoorDataSchema";
import { ElementTypeEnum } from "../../elementTypeMappings";
import IfcDoorStyleOperationEnum from "../../enums/IfcDoorStyleOperationEnum";

export default class DoorData extends ProductData {

    operationType: IfcDoorStyleOperationEnum;

    constructor(mappingId: string | undefined, operationType: string) {
        super(ElementTypeEnum.Door, mappingId);
        this.operationType = (operationType in IfcDoorStyleOperationEnum)
            ? (IfcDoorStyleOperationEnum as any)[operationType]
            : IfcDoorStyleOperationEnum.USERDEFINED;
    }

    static fromJSON(json: any): ProductData {

        const parsed = apiDoorDataSchema.parse(json);

        return new DoorData(    parsed.mappingId ?? undefined, 
                                parsed.operationType);

    }
}